import React, {Fragment} from "react"

// Material-UI Core
import {makeStyles, withStyles} from '@material-ui/core/styles'
import Box from '@material-ui/core/Box'
import List from '@material-ui/core/List'
import ListItem from '@material-ui/core/ListItem'
import ListItemText from '@material-ui/core/ListItemText'
import ListItemAvatar from '@material-ui/core/ListItemAvatar'
import ListItemSecondaryAction from '@material-ui/core/ListItemSecondaryAction'
import Tooltip from '@material-ui/core/Tooltip'
import LinearProgress from '@material-ui/core/LinearProgress'

// Material-UI Icon
import IconButton from '@material-ui/core/IconButton'
import GetAppIcon from '@material-ui/icons/GetApp'
import LaunchIcon from '@material-ui/icons/Launch'
import DeleteForeverIcon from '@material-ui/icons/DeleteForever'

// Custom Style
import attachmentChipStyle from "../../styles/jss/components/chip/attachmentChipStyle"


// Customer List
const AttachmentListItem = withStyles(theme => ({
	root: {
		height: theme.spacing(4),
		paddingTop: theme.spacing(0),
		paddingBottom: theme.spacing(0),
	},

	secondaryAction: {
		paddingRight: 150
	},
})) (ListItem)


const useStyles = makeStyles(theme => attachmentChipStyle(theme))

const AttachmentChip = props => {
	const classes = useStyles()
	const {id, filename, fileSize, fileExtension, uploading, viewFileAction, downloadFileAction, fileRemoveAction/*, setPreviewDialogMode*/} = props
	
	return (
		<Fragment>
			<Box key={id} className={classes.attachmentLabel}>
				<List>
					<AttachmentListItem>
						<ListItemAvatar>
							<img src={require('../../img/file/' + fileExtension.toLowerCase() + '.png')} className={classes.fileTypeImage} />
						</ListItemAvatar>

						<ListItemText 
							classes={{primary: classes.attachmentNameText, secondary: classes.attachmentSizeText}}
							primary={filename}
							secondary={uploading ? <LinearProgress /> : fileSize ?  fileSize / 1024 > 1024 ? (fileSize / 1024 / 1024).toFixed(2) + " MB" : (fileSize / 1024).toFixed(2) + " KB" : ""}
						/>

						<ListItemSecondaryAction>
							{
								viewFileAction ?
									<Tooltip title="View File">
										<IconButton 
											aria-label="view_file"
											onClick={viewFileAction}
											disabled={fileExtension.toLowerCase() === "pdf" ? false : true}
											className={classes.attachmentLabelBtn}
										>
											<LaunchIcon />
										</IconButton>
									</Tooltip>
								: ""
							}

							{
								downloadFileAction ?
									<Tooltip title="Download File">
										<IconButton aria-label="donnload_file" onClick={downloadFileAction} className={classes.attachmentLabelBtn}>
											<GetAppIcon />
										</IconButton>
									</Tooltip>
								: ""
							}

							{
								fileRemoveAction ?
									<Tooltip title="Remove File">
										<IconButton aria-label="remove_file" onClick={fileRemoveAction} className={classes.attachmentLabelBtn}>
											<DeleteForeverIcon />
										</IconButton>
									</Tooltip>
								: ""
							}
						</ListItemSecondaryAction>
					</AttachmentListItem>
				</List>
			</Box>
		</Fragment>
	)
}


export default AttachmentChip